import { toast as rht, ToastOptions, Toast } from "react-hot-toast";
import { ReactNode } from "react";

export interface ToastMessage {
  (t: Toast): ReactNode;
}

export interface PromiseMessages<T = unknown> {
  loading: ReactNode;
  success: ReactNode | ((data: T) => ReactNode);
  error: ReactNode | ((err: unknown) => ReactNode);
}

const defaultOptions: ToastOptions = {
  duration: 3000,
  position: "top-right",
};

const success = (
  msg: ReactNode | ToastMessage,
  opts?: ToastOptions
): string => {
  return rht.success(msg as any, { ...defaultOptions, ...opts });
};

const error = (
  msg: ReactNode | ToastMessage,
  opts?: ToastOptions
): string => {
  return rht.error(msg as any, { ...defaultOptions, ...opts });
};

const loading = (
  msg: ReactNode | ToastMessage,
  opts?: ToastOptions
): string => {
  return rht.loading(msg as any, { ...defaultOptions, ...opts });
};

const warning = (
  msg: ReactNode | ToastMessage,
  opts?: ToastOptions
): string => {
  return rht(msg as any, {
    ...defaultOptions,
    ...opts,
    icon: "⚠️",
    style: {
      background: "#ffffff",
      color: "#92400e",
      ...opts?.style,
    },
  });
};

const promise = async <T>(
  myPromise: Promise<T>,
  msgObj: PromiseMessages<T>,
  opts?: ToastOptions
) => {
  return rht.promise(
    myPromise,
    {
      loading: msgObj.loading,
      success: msgObj.success,
      error: msgObj.error,
    },
    { ...defaultOptions, ...opts }
  );
};

const dismiss = (toastId?: string): void => {
  rht.dismiss(toastId);
};

const toast = {
  success,
  error,
  warning,
  loading,
  promise,
  dismiss,
};

export default toast;